import { render, staticRenderFns } from "./projectTagDialog.vue?vue&type=template&id=704decfe"
import script from "./projectTagDialog.vue?vue&type=script&lang=js"
export * from "./projectTagDialog.vue?vue&type=script&lang=js"
import style0 from "./projectTagDialog.vue?vue&type=style&index=0&id=704decfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports